import icon0 from '@/shared/assets/icons/plp-type-filters/all.png';
import icon1 from '@/shared/assets/icons/plp-type-filters/anklets.png';
import icon2 from '@/shared/assets/icons/plp-type-filters/bangles.png';
import icon3 from '@/shared/assets/icons/plp-type-filters/bracelets.png';
import icon4 from '@/shared/assets/icons/plp-type-filters/brooch.png';
import icon5 from '@/shared/assets/icons/plp-type-filters/chains.png';
import icon6 from '@/shared/assets/icons/plp-type-filters/charms.png';
import icon7 from '@/shared/assets/icons/plp-type-filters/cufflinks.png';
import icon8 from '@/shared/assets/icons/plp-type-filters/earrings.png';
//import icon9 from '@/shared/assets/icons/plp-type-filters/gold-coins.png';
import icon10 from '@/shared/assets/icons/plp-type-filters/hair-pins.png';
import icon11 from '@/shared/assets/icons/plp-type-filters/maang-tikka.png';
import icon12 from '@/shared/assets/icons/plp-type-filters/mangalsutra.png';
import icon13 from '@/shared/assets/icons/plp-type-filters/necklaces.png';
import icon14 from '@/shared/assets/icons/plp-type-filters/nose-accessory.png';
import icon15 from '@/shared/assets/icons/plp-type-filters/pendants.png';
import icon16 from '@/shared/assets/icons/plp-type-filters/rings.png';
//import icon17 from '@/shared/assets/icons/plp-type-filters/solitaire-earring.png';
//import icon18 from '@/shared/assets/icons/plp-type-filters/solitaire-pendant.png';
//import icon19 from '@/shared/assets/icons/plp-type-filters/solitaire-ring.png';
import icon20 from '@/shared/assets/icons/plp-type-filters/tie-pin.png';
import icon21 from '@/shared/assets/icons/plp-type-filters/watch-accessory.png';

// Complete type-strip catalogue; every entry is visible regardless of API filters.
// to add solitaire paste this in it
//Solitaire Earring': icon17,
//  'Solitaire Pendant': icon18,
//  'Solitaire Ring': icon19,
//  'Gold Coins': icon9,
export const TYPE_FILTER_STRIP_ASSETS: Readonly<Record<string, string>> = {
  'All': icon0,
  'Rings': icon16,
  'Earrings': icon8,
  'Chains': icon5,
  'Bracelets': icon3,
  'Pendants': icon15,
  'Necklaces': icon13,
  'Bangles': icon2,
  'Mangalsutra': icon12,
  'Nose Accessory': icon14,
  'Charms': icon6,
  'Anklets': icon1,
  'Maang Tikka': icon11,
  'Cufflinks': icon7,
  'Watch Accessory': icon21,
  'Tie Pin': icon20,
  'Brooch': icon4,
  'Hair Pins': icon10,
};
